export const OBJECT_STATUS_MAP = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  IN_OFFER: 'in-offer',
};

export const OBJECT_STATUS_COLORS = {
  [OBJECT_STATUS_MAP.ACTIVE]: 'bg-green',
  [OBJECT_STATUS_MAP.INACTIVE]: 'bg-gray-dark',
  [OBJECT_STATUS_MAP.IN_OFFER]: 'bg-blue-dark',
};

export const OBJECT_LOCALIZATION = {
  IN_BUILDING: 'inBuilding',
  ON_BUILDING: 'onBuilding',
  NEXT_TO_BUILDING: 'nextToBuilding',
  OUTSIDE: 'outside',
};

export const YOUTUBE_REGEX =
  /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})(\S*)?$/;

export const YOUTUBE_EMBED_REGEX =
  /^https?:\/\/(www\.)?youtube\.com\/embed\/([a-zA-Z0-9_-]{11})(\?.*)?$/;

export const YOUTUBE_VIDEO_ID_REGEX =
  /(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
